import { Controller } from "@hotwired/stimulus";

// Countdown to the next daily free-question reset (midnight in the company's
// time zone), shown in the limit-reached "tomorrow note". Mirrors the HH:MM:SS
// formatting of ApplicationHelper#reset_countdown_text so the server-rendered
// value and the first tick agree.
export default class extends Controller {
  static targets = ["display"];
  static values = {
    // Seconds left at render time, computed server-side
    // (LimitReachedController#show -> @seconds_until_reset).
    remainingSeconds: Number
  };

  connect() {
    // Anchor the deadline to the device clock at load (now + remaining). Both
    // the anchor and every tick read Date.now(), so the absolute clock cancels
    // out and only elapsed wall-clock matters — immune to clock skew.
    this.deadlineAt = Date.now() + this.remainingSecondsValue * 1000;
    this.updateTimer();
    this.intervalId = setInterval(() => this.updateTimer(), 1000);
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateTimer() {
    const remaining = Math.round((this.deadlineAt - Date.now()) / 1000);

    if (remaining <= 0) {
      this.displayTarget.textContent = "00:00:00";
      this.handleReset();
      return;
    }

    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;
    this.displayTarget.textContent =
      `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  handleReset() {
    clearInterval(this.intervalId);
    // The allowance has rolled over — reload so the page re-evaluates the limit.
    window.location.reload();
  }
}
